/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Filter_ToInputs */

const vi_expense_filter_to = /** @type {(inputs: Expense_Filter_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến ngày`)
};

/**

* @param {Expense_Filter_ToInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_filter_to = /** @type {((inputs?: Expense_Filter_ToInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Filter_ToInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_filter_to(inputs)
});